import { APIClient } from "../helpers/api_helper";
import * as url from "../helpers/url_helper";
import { DepartmentItem } from "../interfaces/Department";
import { DepartmentsResponse } from "../slices/departments/types";

const api = new APIClient();

// Check if we should use the fake backend
export const getAllDepartments = (
    pageNumber: number = 1,
    pageSize: number = 50
): Promise<DepartmentsResponse> => {
    
    // Real API call with query parameters - typed response
    return api.get<DepartmentsResponse>(url.GET_DEPARTMENTS, {
        pageNumber,
        pageSize,
    });
};

export const createDepartment = (data: Partial<DepartmentItem>): Promise<DepartmentItem> => {
    
    return api.create<DepartmentItem>(url.POST_DEPARTMENT, data);
};

export const updateDepartment = (
    id: string,
    data: Partial<DepartmentItem>
): Promise<DepartmentItem> => {
    
    return api.put<DepartmentItem>(url.PUT_DEPARTMENT + "/" + id, data);
};

export const deleteDepartment = (id: string): Promise<void> => {
    
    return api.delete<void>(url.DELETE_DEPARTMENT + "/" + id);
};
